import { Component, Input } from '@angular/core';
import { IconComponent } from '@kin/spark-ui';

interface Step {
  number: number;
  label: string;
}

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.css',
})
export class StepperComponent {
  @Input({ required: true }) currentStep!: number;

  readonly steps: Step[] = [
    { number: 1, label: 'Confirm & Authorize' },
    { number: 2, label: 'Sign' },
    { number: 3, label: 'Your Case' },
  ];
}
